module.exports = __webpack_public_path__ + "static/img/Lyon-Stadium.f871436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lyon-Stadium.jpg
// module id = nM6W
// module chunks = 0